import React, { memo } from "react";

export const SVGIcon = ({
  width = "84",
  height = "84",
  viewBox = "0 0 84 84",
  children,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox={viewBox}
    {...props}
  >
    {children}
  </svg>
);

export default memo(SVGIcon);
